 
export enum CopyAdviceEvents {
  CopyTreatmentsStarted = 'Arable_CopyTreatmentsStarted',
  CompletedCopyTreatments = 'Arable_CompletedCopyTreatments',
  CopyByTreatmentsStarted = 'Arable_CopyByTreatmentsStarted',
  CompletedCopyByTreatments = 'Arable_CompletedCopyByTreatments',
  CopyExecutedTreatmentsStarted = 'Arable_CopyExecutedTreatmentsStarted',
  CompletedCopyExecutedTreatments = 'Arable_CompletedCopyExecutedTreatments',
}

export interface CopyAdviceState {
  amountOfAdvicesCopying?: number;
  amountOfAdvicesCompleted?: number;
  copyDialogDismissed?: boolean;
  copyStatusDismissed?: boolean;
}

export interface CopyTreatmentsStarted {
  amountOfAdvices: number;
}

export interface CompletedCopyTreatments {
  isSuccessful: boolean;
  message?: string;
}
